// Application constants

// Feature Flags
export const FEATURES = {
  ENABLE_GUEST_CHECKOUT: true, // Allow checkout without login
  ENABLE_WHATSAPP_ORDER: true, // Show WhatsApp quick order button
  ENABLE_MOBILE_STICKY_BAR: true, // Show mobile sticky checkout bar
  SHOW_STOCK_URGENCY: true, // Show "Only X left" messages
  ENABLE_LAZY_LOADING: true // Lazy load images and reviews
};

// Kenya-specific constants
export const KENYA = {
  WHATSAPP_NUMBER: '254720463710', // Business WhatsApp number
  WHATSAPP_MESSAGE_TEMPLATE: 'Hi Quickcrate, I want to order {productName} - {productUrl}',
  MPESA_PAYBILL: '400200', // Replace with actual paybill/till number
  MPESA_ACCOUNT: 'QUICKCRATE', // Replace with actual account name
  DELIVERY: {
    NAIROBI_SAME_DAY: 'Same Day Delivery',
    NAIROBI_FEE: 200,
    OTHER_COUNTIES_DAYS: '1-3 Days',
    OTHER_COUNTIES_FEE: 350,
    FREE_DELIVERY_THRESHOLD: 5000
  },
  COUNTIES: [
    'Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Thika', 'Malindi', 
    'Kitale', 'Garissa', 'Kakamega', 'Machakos', 'Meru', 'Nyeri', 'Kericho',
    'Naivasha', 'Kisii', 'Bomet', 'Bungoma', 'Embu', 'Homa Bay', 'Isiolo',
    'Kajiado', 'Kapsabet', 'Karuri', 'Khandleri', 'Kiambu', 'Kilifi', 'Kirinyaga',
    'Kitui', 'Kwale', 'Laikipia', 'Lamu', 'Lodwar', 'Makueni', 'Mandera',
    'Marsabit', 'Migori', 'Murang\'a', 'Nandi', 'Nanyuki', 'Narok', 'Nyamira',
    'Nyandarua', 'Samburu', 'Siaya', 'Taita Taveta', 'Tana River', 'Tharaka Nithi',
    'Trans Nzoia', 'Turkana', 'Uasin Gishu', 'Vihiga', 'Wajir', 'West Pokot'
  ]
};

export const IMAGES = {
  PLACEHOLDER: '/Images/placeholder.jpg',
  DEFAULT_PRODUCT: '/Images/placeholder.jpg',
  NO_IMAGE_AVAILABLE: '/Images/placeholder.jpg',
  MPESA_LOGO: '/Images/Mpesa.jpeg',
  SAFARICOM_LOGO: '/Images/safaricom-logo.png',
  DELIVERY_TRUCK: '/Images/delivery-truck-icon.png',
  SECURE_CHECKOUT: '/Images/secure-checkout.png'
};

export const SEARCH = {
  DEFAULT_RESULTS_PER_PAGE: 16,
  DEFAULT_SORT: 'relevance',
  PRICE_RANGE_DEFAULT: [0, 100000],
  MAX_FILTERS_DISPLAYED: 10
};

export const API_ENDPOINTS = {
  // Add any API endpoint constants here if needed
};

export const UI_TEXT = {
  NO_RESULTS_FOUND: 'No products found',
  LOADING_SEARCH: 'Searching',
  CLEAR_FILTERS: 'Clear All Filters',
  SORT_BY: 'Sort by',
  DEPARTMENT: 'Department',
  PRICE: 'Price',
  BRAND: 'Brand',
  CUSTOMER_REVIEW: 'Customer Review',
  AVAILABILITY: 'Availability',
  // Kenya-specific text
  PAY_ON_DELIVERY_NAIROBI: 'Pay on Delivery Available in Nairobi',
  MPESA_ACCEPTED: 'M-Pesa Payment Accepted',
  SECURE_CHECKOUT: '100% Secure Checkout',
  EASY_RETURNS: 'Easy Returns within 7 Days',
  STOCK_URGENCY: 'Only {count} left in stock!',
  FAST_DELIVERY_NAIROBI: 'Same Day Delivery in Nairobi',
  FAST_DELIVERY_KENYA: '1-3 Days Delivery Countrywide'
};